/* eslint no-unused-vars:off */
enum ExportStatus {
  IN_PROGRESS = "in_progress",
  SUCCESS = "success",
  SUCCESS_WITH_IGNORED = "success_with_ignored",
  ERROR = "error",
}

export default ExportStatus;
